<form [formGroup]="addMedicineForm">
  <ng-template matStepLabel>Select Medicine</ng-template>
  <div class="row mt-4">
    <div class="col-md-6">

      <p>
        <mat-form-field appearance="outline">
          <mat-label>Search for medicine</mat-label>
          <input required [disabled]="isLoading" data-testid="add-medicine-name" type="text"
            placeholder="Search for medicine" aria-label="Search for medicine" matInput
            formControlName="medicineFilter" [matAutocomplete]="auto">
            <mat-autocomplete data-testid="add-medicine-autocompletion-list"
              (optionSelected)="medicineSelected($event)" autoActiveFirstOption #auto="matAutocomplete">
              @for (med of medicine; track med) {
                <mat-option [value]="med">
                  {{med.name}}
                </mat-option>
              }
            </mat-autocomplete>
            <mat-icon matPrefix>search</mat-icon>
            @if (addMedicineForm.get('medicineFilter')?.invalid) {
              <mat-error>
                Medicine is invalid
              </mat-error>
            }
          </mat-form-field>
        </p>


        <p>
          <mat-form-field appearance="outline">
            <mat-label>Select package type</mat-label>
            <mat-select (selectionChange)="packageTypeSelected($event)" required
              data-testid="add-medicine-package-type" formControlName="packageType">
              @for (type of medicineDosageTypePackageTypes; track type) {
                <mat-option [value]="type">
                  {{type.package_type.type}} ({{type.contained_quantity}})
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </p>

      </div>
      <div class="col-md-6">

        <p>
          <mat-form-field appearance="outline">
            <mat-label>Select dosage type</mat-label>
            <mat-select required data-testid="add-medicine-dosage-type"
              [disabled]="isLoading || (dosageTypes.length === 0)" formControlName="dosageType"
              (selectionChange)="getMedicineDosagePackageTypes($event)">
              @for (type of dosageTypes; track type) {
                <mat-option [disabled]="type.is_active === 0" [value]="type">
                  {{type.additional_information}}
                </mat-option>
              }
            </mat-select>
            @if (addMedicineForm.get('dosageType')?.invalid) {
              <mat-error>
                Dosage type is invalid
              </mat-error>
            }
          </mat-form-field>
        </p>

        <p>
          <mat-form-field appearance="outline">
            <mat-label>Quantity</mat-label>
            <input required data-testid="add-medicine-quantity" autocomplete="off" type="number" min="1"
              formControlName="quantity" matInput placeholder="Quantity">
              @if (addMedicineForm.get('quantity')?.invalid) {
                <mat-error>
                  Quantity is invalid
                </mat-error>
              }
              @if (selectedMedicineDosagePackageType) {
                <mat-hint>
                  <span class="units-available fontweight-bold">{{selectedMedicineDosagePackageType.stock_on_hand}} units available</span>
                </mat-hint>
              }
            </mat-form-field>
          </p>



        </div>
      </div>
      <p>
        <button [disabled]="addMedicineForm.invalid || isLoading || !selectedDosageType" data-testid="add-medicine-add-button" type="button"
          (click)="addOrderItem()" class="mx-1" mat-stroked-button>
          <mat-icon>add</mat-icon> Add
        </button>
      </p>
    </form>